import { Injectable } from "@angular/core";
import { IID_EP_RISPOSTA } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDEpRispostaStore } from "./iidEPRisposta.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataQuery(InterfaceName.RISPOSTA)
  export class IIDEpRispostaQuery extends AbstractInterfaceDataQuery<IID_EP_RISPOSTA> {
  
    constructor(protected store: IIDEpRispostaStore) {
      super(store);
    }
  }